<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'home-layout'
}
</script>
<style lang="scss" scoped>
</style>
